import { EyeIcon } from '@heroicons/react/24/outline';
import { PencilIcon, LinkIcon } from '@heroicons/react/24/solid';
import { useState } from 'react';
import FormResponseModal from '../Modal/FormResponsesModal';
import FormResponseModalV2 from '../Modal/FormResponsesModalV2';

function FormsItems({ forms, onEdit }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [responseModalOpen, setResponseModalOpen] = useState(false);
  const [editingFormId, setEditingFormId] = useState(null);
  const [editingForm, setEditingForm] = useState(null);

  const itemsPerPage = 10;
  const totalPages = forms ? Math.ceil(forms.length / itemsPerPage) : 1;

  const currentItems = forms.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  const truncate = (text, length) => {
    if (!text) return "";
    return text.length > length ? text.substring(0, length) + "..." : text;
  };

  const formatDescription = (descArray) => {
    if (!Array.isArray(descArray)) return "";
    return descArray.join(" ");
  };

  const handleShare = (formId) => {
    const shareUrl = `${window.location.origin}/forms/${formId}`;
    navigator.clipboard.writeText(shareUrl)
      .then(() => alert("Link copied to clipboard!"))
      .catch(() => alert("Failed to copy link."));
  };

  const openResponseModal = (form) => {
    setEditingFormId(form.id);
    setEditingForm(form);
    setResponseModalOpen(true);
  };

  return (
    <>
      {/* Response Modal */}
      {editingForm?.backendVersion === 2 ? 
      <FormResponseModalV2 
        open={responseModalOpen} 
        setOpen={setResponseModalOpen} 
        formId={editingFormId} 
        editingForm={editingForm}></FormResponseModalV2>
      : <FormResponseModal 
        open={responseModalOpen} 
        setOpen={setResponseModalOpen} 
        formId={editingFormId} 
        editingForm={editingForm} 
      />}

      <div className="w-full overflow-x-auto">
        <table className="w-full md:min-w-full text-sm text-left">
          <thead className="bg-gray-800 text-gray-200 hidden md:table-header-group">
            <tr>
              <th className="px-4 py-3">Name</th>
              <th className="px-4 py-3">Description</th>
              <th className="px-4 py-3">Responses</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((form) => {
              const fullDescription = formatDescription(form.descriptions);
              return (
                <tr
                  key={form.id}
                  className="border border-gray-200 shadow-sm md:table-row block md:border-0 rounded-lg mb-4 md:mb-0"
                >
                  {/* Form Name + Edit + Share */}
                  <td className="px-4 py-3 font-semibold block md:table-cell">
                    <div className="flex items-center justify-between">
                      <span>{form.title}</span>
                      <div className="flex space-x-2">
                        {/* Edit button */}
                        <button
                          className="text-gray-600 p-2 rounded-full hover:bg-gray-100"
                          onClick={() => onEdit(form)}
                        >
                          <PencilIcon className="w-4 h-4" />
                        </button>

                        {/* Share button */}
                        {form.status !== "Closed" ? 
                        <button
                          className="text-gray-600 p-2 rounded-full hover:bg-gray-100"
                          onClick={() => handleShare(form.id)}
                        >
                          <LinkIcon className="w-4 h-4" />
                        </button>:null}
                      </div>
                    </div>
                  </td>

                  {/* Description */}
                  <td className="px-4 py-3 text-gray-600 block md:table-cell">
                    {form?.backendVersion === 2 ? form.description : truncate(fullDescription, 100)}
                  </td>

                  {/* Responses */}
                  <td className="px-4 py-3 text-gray-900 font-medium block md:table-cell">
  <div className="flex items-center space-x-1">
    {/* Show label only on mobile */}
    <span className="sm:hidden">Responses:</span>
    <span>{form.responses ? form.responses.length : 0}</span>
    <button
      className="text-gray-600 hover:text-gray-800"
      onClick={() => openResponseModal(form)}
    >
      <EyeIcon className="w-5 h-5" />
    </button>
  </div>
</td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {/* Pagination */}
        <div className="flex flex-1 items-center justify-between sm:hidden mt-4">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="px-3 py-2 bg-gray-300 rounded disabled:opacity-50"
          >
            Prev
          </button>
          <span className="px-2">
            {currentPage} / {totalPages}
          </span>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="px-3 py-2 bg-gray-300 rounded disabled:opacity-50"
          >
            Next
          </button>
        </div>
      </div>
    </>
  );
}

export default FormsItems;
